const updates = [
  {
    date: '07-31',
    title: '《流浪地球3》定档暑期 科幻巨制再掀观影热潮',
    tag: '新片上线',
  },
  {
    date: '07-30',
    title: '热门韩剧《黑暗荣耀》第二季全集高清上线',
    tag: '剧集更新',
  },
  {
    date: '07-29',
    title: '奥斯卡获奖影片《奥本海默》4K修复版已更新',
    tag: '高清修复',
  },
  {
    date: '07-28',
    title: '国产悬疑剧《漫长的季节》完整版一次性放出',
    tag: '全集上线',
  },
  {
    date: '07-27',
    title: '2026暑期档热门大片《封神第二部》抢先上线',
    tag: '抢先看',
  },
  {
    date: '07-26',
    title: '日本动漫《鬼灭之刃》最终季高清全集更新完毕',
    tag: '动漫完结',
  },
  {
    date: '07-25',
    title: '平台新增杜比音效专区 带来影院级声效体验',
    tag: '功能升级',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            本周快讯
          </h2>
          <p className="text-foreground-600 text-sm mt-2">最新影视动态与资源更新，不错过每一部好片</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200 hidden md:block"></div>

          <div className="space-y-4">
            {updates.map((item, i) => (
              <div key={i} className="flex items-start gap-4 md:gap-6 group">
                <div className="hidden md:flex flex-col items-center pt-1">
                  <span className="w-[39px] h-[39px] rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-xs font-semibold whitespace-nowrap border-2 border-background-50 shrink-0">
                    {item.date}
                  </span>
                </div>

                <div className="flex-1 bg-background-100 rounded-lg px-4 py-3 md:px-5 md:py-3.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 border border-background-200/60 hover:border-primary-200 transition-colors cursor-default">
                  <span className="inline-flex md:hidden text-xs text-foreground-500 font-medium bg-background-200/70 px-2 py-0.5 rounded whitespace-nowrap w-fit">
                    {item.date}
                  </span>
                  <span className="text-xs font-semibold text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full whitespace-nowrap w-fit shrink-0">
                    {item.tag}
                  </span>
                  <span className="text-sm text-foreground-800 leading-relaxed">{item.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}